import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Martín G.',
  location: 'Buenos Aires',
  rating: 5,
  text: 'Tenía una Yamaha RX que perdía fuerza en subida. Seguí la guía de carburación y ahora anda como nueva. Increíble.',
  bike: 'Yamaha RX 115'
}, {
  name: 'Lucas P.',
  location: 'Córdoba',
  rating: 5,
  text: 'Me ahorré más de $30.000 en mecánicos. La tabla de diagnóstico de fallas es oro puro, encontré el problema en 10 minutos.',
  bike: 'Suzuki AX 100'
}, {
  name: 'Diego R.',
  location: 'Mendoza',
  rating: 5,
  text: 'Soy mecánico hace 5 años y aún así aprendí cosas nuevas. Las tablas de carburación están muy bien hechas.',
  bike: 'Profesional'
}, {
  name: 'Franco M.',
  location: 'Rosario',
  rating: 5,
  text: 'Compré la guía sin saber nada de motores. Hoy ya le hago el mantenimiento completo a mi moto yo solo.',
  bike: 'Zanella ZB 110'
}, {
  name: 'Sebastián L.',
  location: 'Tucumán',
  rating: 4,
  text: 'La puesta a punto paso a paso es genial. Mi moto nunca anduvo tan bien. 100% recomendado.',
  bike: 'Honda MB 100'
}, {
  name: 'Nicolás V.',
  location: 'Santa Fe',
  rating: 5,
  text: 'El checklist imprimible lo tengo pegado en el taller. Cada vez que toco un motor lo uso. Vale cada peso.',
  bike: 'Taller propio'
}];
function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex gap-0.5" data-id="element-193">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`w-4 h-4 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-600'}`} data-id="element-194" />)}
    </div>;
}
export function ReviewsSection() {
  return <section className="w-full bg-gradient-to-b from-gray-900 to-motor-black py-14 px-4 sm:px-6 lg:px-8" data-id="element-195">
      <div className="max-w-6xl mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-197">
          <h2 className="font-bebas text-4xl sm:text-5xl lg:text-6xl text-white uppercase mb-3" data-id="element-198">
            ⭐ LO QUE DICEN NUESTROS CLIENTES
          </h2>
          <p className="text-lg text-gray-400 font-montserrat" data-id="element-199">
            Más de 500 motoqueros ya confían en Motor 2T Pro
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-200">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-gray-800/60 border border-gray-700 rounded-lg p-4 space-y-3 hover:border-motor-red/40 transition-all duration-300" data-id="element-201">
              <StarRating rating={review.rating} data-id="element-202" />
              <p className="text-gray-300 font-montserrat text-xs leading-relaxed italic" data-id="element-203">
                "{review.text}"
              </p>
              <div className="flex items-center justify-between pt-2 border-t border-gray-700" data-id="element-204">
                <div data-id="element-205">
                  <p className="text-white font-montserrat font-semibold text-xs" data-id="element-206">
                    {review.name}
                  </p>
                  <p className="text-gray-500 font-montserrat text-xs" data-id="element-207">
                    {review.location}
                  </p>
                </div>
                <span className="text-motor-red font-montserrat text-xs font-semibold bg-motor-red/10 px-2 py-0.5 rounded-full border border-motor-red/30" data-id="element-208">
                  {review.bike}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}